export default __webpack_public_path__ + "static/media/headerImage1.91677837.jpg";